import styled from 'styled-components';

import { StyledFlex } from '@dreryk/react-components';

export const StyledServiceProvidingLocationCellTooltip = styled(StyledFlex)`
   border-radius: 16px;
   height: 16px;
   width: 18px;
   background-color: ${({ theme }) => theme.primary};
`;
StyledServiceProvidingLocationCellTooltip.displayName = 'StyledServiceProvidingLocationCellTooltip';
